import { useStore } from '../store';
import { PermissionSlug } from '../constants/featureFlags';

/**
 * Whether this agency actually runs on the Roger EMR.
 *
 * The raw agency flag and nothing else, so a caller deciding whether to reach
 * for an EMR-only endpoint gets the truth rather than a display decision.
 */
export function useIsAgencyRogerEmrEnabled(): boolean {
  return useStore(state => state.user?.agency?.is_rogeremr_enabled === true);
}

/**
 * Whether the User Manager should offer its EMR surface at all.
 *
 * A different question from the one above, which is why it has its own name.
 * Intake, coding and Scribe agencies have no visits, no clinic assignments and
 * no clinical titles, so showing them the archetype cards and the EMR role
 * catalogue describes a product they have not bought.
 *
 * Super users are the exception. Roger staff administer those agencies through
 * the agency switcher and still have to be able to grant every role, so
 * narrowing the screen under them would take away the only place that work
 * happens.
 */
export function useShowEmrUserManagement(): boolean {
  const isAgencyRogerEmrEnabled = useIsAgencyRogerEmrEnabled();
  const isSuperUser = useStore(state =>
    state.hasPermission(PermissionSlug.ADMIN_SUPER_USER)
  );
  return isAgencyRogerEmrEnabled || isSuperUser;
}
